export default "__VITE_ASSET__BxPHXfq4__"